import { useRef } from 'react'

/**
 * @function
 * @description Returns a function to get the correct current props. This is used for component callbacks that have stale
 * props when referencing props.
 * @param {object} props Component props.
 * @returns {void}
 */
const useCurrentProps = props => {
  const currentProps = useRef({})
  currentProps.current = props

  const getCurrentProps = () =>
    currentProps.current

  return getCurrentProps
}

export default useCurrentProps